import styles from "./PriceText.module.css";
import { useEffect, useState } from "react";
export default function PriceText({ value, selected }) {
  const [display, setDisplay] = useState("");

  if (value == null) return null;

  const formatted = value.toLocaleString("fa-IR"); // مثلا "۱۰۰٬۰۰۰" یا "100,000"

  // پیدا کردن آخرین جداکننده (هم کامای انگلیسی، هم جداکننده عربی)
  const commaIndex = formatted.lastIndexOf(",");
  const arabicSepIndex = formatted.lastIndexOf("٬"); // U+066C
  const sepIndex = Math.max(commaIndex, arabicSepIndex);

  let mainPart = formatted;
  let smallPart = "";

  if (sepIndex !== -1) {
    mainPart = formatted.slice(0, sepIndex); // تا قبل از جداکننده
    smallPart = formatted.slice(sepIndex); // خود جداکننده + سه رقم آخر
  }

  return (
    <div className={`${styles.wrapMain} ${selected ? styles.selected : ""}`}>
      <div className={styles.wrapper}>
        <span className={styles.main}>{mainPart}</span>
        {smallPart && <span className={styles.decimals}>{smallPart}</span>}
        <span className={styles.currency}></span>
      </div>
      تومان
    </div>
  );
}
